import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductModel } from 'src/app/models/product.model';
import { ProfileModel } from 'src/app/models/profile.model';

@Component({
  selector: 'product-ordered',
  templateUrl: './product-ordered.component.html',
  styleUrls: ['./product-ordered.component.scss'],
})
export class ProductOrderedComponent implements OnInit {
  @Input()
  item:ProductModel;

  @Input()
  producer:ProfileModel;

  constructor(public route:ActivatedRoute,) {
    this.route.data
      .subscribe((data) => {
        if(data.product){
          this.item = data.product;
        }
        if(data.producer){
          this.producer = data.producer;
        }
      });
  }

  ngOnInit() {
  }
  
}
